export default {
  contact: 'tests.columns.contact',
  routing: 'tests.columns.routing',
  partners: 'tests.columns.partners',
  estimatedSamplingTime: 'tests.columns.estimatedSamplingTime',
  massTestsFile: 'tests.columns.massTestsFile',
  fileDefinition: 'tests.columns.fileDefinition',
  samplingMethod: 'tests.columns.samplingMethod'
}
